import React from 'react'
import { DefaultDataTable } from '../../../components/dataTable/DefaultDataTable'

export const BandeiraList = (props) => <DefaultDataTable data={props} />
